var _excluded = ["className", "fixed", "size", "fillCurrent", "strokeCurrent"];

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

import React from 'react';
import classnames from 'classnames';

var addLunaClass = function addLunaClass(_ref) {
  var _classnames;

  var className = _ref.className,
      fixed = _ref.fixed,
      size = _ref.size,
      fillCurrent = _ref.fillCurrent,
      strokeCurrent = _ref.strokeCurrent,
      props = _objectWithoutPropertiesLoose(_ref, _excluded);

  return Object.assign({}, props, {
    className: classnames(className, 'ln-c-icon', (_classnames = {
      'ln-c-icon--fixed': fixed
    }, _classnames["ln-c-icon--" + size] = size, _classnames['ln-c-icon--fill-current'] = fillCurrent, _classnames['ln-c-icon--stroke-current'] = strokeCurrent, _classnames))
  });
};

export { addLunaClass };
export default (function (Component) {
  var Composed = function Composed(props) {
    return /*#__PURE__*/React.createElement(Component, addLunaClass(props));
  };

  Composed.displayName = Component.displayName || Component.name || 'Icon';
  return Composed;
});